<template>
  <div class="fieldset mt-4" v-if="subMenu && subMenuData && countFieldItems()">
    <legend class="md-whiteframe-z2" align="center">
      {{ subMenu["@attributes"].txtid | translate }}
    </legend>
    <v-flex v-if="subMenu.field && subMenu.field.length">
      <v-layout
        row
        wrap
        align-center
        v-for="(fields, index) in subMenu.field"
        :key="fields['@attributes'].txtid + index"
      >
        <field-item
          v-if="fields['@attributes'].type !== 'dummy'"
          :fields="fields"
          :sub-menu-data="subMenuData[fields['@attributes'].udp]"
          :udp-dependency="subMenuData[fields['@attributes'].udpdependency]"
          :sub-menu-select-data="findSelectFieldData(fields)"
          :sub-menu-output-setting="subMenuOutputSetting"
          @openRangeSliderDialog="openRangeSliderDialog($event, fields)"
          @saveSelectFieldUdp="saveSelectFieldUdp($event)"
          @saveSelectFieldData="saveSelectFieldData($event)"
          @showResponseAlert="showResponseAlert($event)"
          @openTimerComponent="$emit('openTimerPage')"
          @openWeatherTimerComponent="$emit('openWeatherTimerPage')"
          :showHelpdialog="showHelpdialog"
        />
      </v-layout>
    </v-flex>
    <v-flex
      v-if="
        subMenu.field &&
          !subMenu.field.length &&
          subMenu.field['@attributes'].type === 'graph'
      "
    >
      <div
        style="width:200;height:300px"
        class="wrap-chart flex charts-align fanChart"
      ></div>
    </v-flex>
    <user-update-field
      v-if="
        subMenu['@attributes'].txtid === 'lng_user_account_menu' ||
          subMenu['@attributes'].txtid === 'lng_user_systeminfo'
      "
      :field-text="selectedFieldText"
      :field-udp="selectedFieldUdp"
      :field-desc="selectedFieldDesc"
      :value-obj="selectedField"
      :selected-language="getLanguage"
      :dialog="closeDialog"
      :openDialog="dialog"
      :on-response="showResponseAlert"
    ></user-update-field>
    <slider-range-dialog
      v-else
      :field-text="selectedFieldText"
      :field-udp="selectedFieldUdp"
      :field-desc="selectedFieldDesc"
      :value-obj="selectedField"
      :selected-language="getLanguage"
      :dialog="closeDialog"
      :openDialog="dialog"
      :on-response="showResponseAlert"
      :key-component="keyComponent"
    ></slider-range-dialog>
    <v-flex v-if="subMenu['@attributes'].txtid === 'lng_messages_account'">
      <div class="sms-buy">Buy SMS at this 
        <a :href="paymentLink">link</a>
      </div>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SliderRangeDialog from "./SliderRangeDialog";
import UserUpdateField from "./UserUpdateField";
import GlobalService from "../services/global-service";
import FieldItem from "./FieldItem";
import { smsPaymentLink } from "../common/Constant";

export default {
  name: "SubMenu",
  data() {
    return {
      dialog: false,
      selectedField: undefined,
      selectedFieldUdp: undefined,
      selectedFieldText: "",
      selectedFieldDesc: "",
      selectField: {},
      selectfieldData: [],
      chartDataToPlot: [],
      keyComponent: 0
    };
  },
  // modal components for "show help text", "update field value" and "give technical access"
  components: {
    SliderRangeDialog,
    UserUpdateField,
    FieldItem
  },
  // async mounted() {
  //   this.selectFieldsInitialize();
  //   this.selectedFieldsInitialize();
  // },
  computed: {
    ...mapGetters("user", ["getUser"]),
    ...mapGetters("global", ["getTechAccess"]),
    ...mapGetters("global", ["getAccessMode"]),
    readOnly() {
      return this.getUser.credentials === "readonly";
    },
    getLanguage() {
      return localStorage.getItem("language");
    },
    paymentLink() {
      return smsPaymentLink
    }
  },
  mounted() {
    if (
      this.subMenu.field &&
      !this.subMenu.field.length &&
      this.subMenu.field["@attributes"].type === "graph"
    ) {
      this.getChartDataToPlot();
      this.plotChart();
    }
  },
  methods: {
    countFieldItems() {
      let userCount = 0,
        smithCount = 0,
        nbeCount = 0;
      if(this.subMenu.field){
        this.subMenu.field.forEach(element => {
          !element["@attributes"].auth ? userCount++ : null;
          element["@attributes"].auth === "smith" ? smithCount++ : null;
          element["@attributes"].auth === "nbe" ? nbeCount++ : null;
        });
      }
      if (this.getAccessMode === "nbe") {
        return userCount ? userCount : smithCount ? smithCount : nbeCount;
      } else if (this.getAccessMode === "smith") {
        return userCount ? userCount : smithCount;
      } else {
        return userCount;
      }
    },
    plotChart() {
      $.plot(
        $(this.$el.getElementsByClassName("fanChart")),
        this.chartDataToPlot,
        this.setChartOptions()
      );
    },
    getChartDataToPlot() {
      let menuData = this.subMenuData;
      this.chartDataToPlot = [
        {
          color: "#FF0000",
          data: [
            [1, menuData["fan.speed_10"].val],
            [2, menuData["fan.speed_50"].val],
            [3, menuData["fan.speed_100"].val]
          ],
          label: "Fan speed"
        },
        {
          color: "#0000FF",
          data: [
            [1, menuData["fan.exhaust_10"].val],
            [2, menuData["fan.exhaust_50"].val],
            [3, menuData["fan.exhaust_100"].val]
          ],
          label: "Exhaust fan speed"
        }
      ];
    },
    setChartOptions() {
      return {
        xaxis: {
          ticks: [[1, "10%"], [2, "50%"], [3, "100%"]]
        },
        points: { show: true },
        lines: { show: true },
        legend: {
          show: true,
          labelBoxBorderColor: "#000",
          noColumns: 2,
          position: "sw"
        },
        grid: {
          hoverable: true,
          borderWidth: 2,
          backgroundColor: {
            colors: ["#999", "#ffffff"]
          }
        },
        // transform: function (v) { console.log('kkkkk: ', v); },
        tooltip: true,
        tooltipOpts: {
          defaultTheme: false,
          content: (label, x, y) => {
            let tooltip = `<div class="tooltip-content graph-bg"><h4>${
              label ? label : ""
            }</h4><ul><li>${y}</li></ul></div>`;
            return tooltip;
          }
        }
      };
    },
    findSelectFieldData(field) {
      let index = -1;
      if (field["@attributes"].fieldset) {
        index = this.subMenuSelectData.findIndex(
          item => item["@attributes"].name == field["@attributes"].fieldset
        );
      }
      return index >= 0 ? this.subMenuSelectData[index] : {};
    },
    // to save the selected field updDependency comes from parent
    saveSelectFieldUdp(udp) {
      this.selectedFieldUdp = udp;
    },
    // open update field's slider range dialog
    openRangeSliderDialog(identifierValueObj, fieldInfo) {
      this.selectedFieldUdp = fieldInfo["@attributes"].udp;
      this.selectedField = identifierValueObj;
      this.selectedFieldText = fieldInfo["@attributes"].txtid;
      this.selectedFieldDesc = fieldInfo["@attributes"].helptxtid;
      this.keyComponent += 1;
      this.dialog = true;
    },
    // close update field's slider range dialog
    closeDialog(val) {
      this.dialog = val;
    },
    // to update the dropdown field data
    async saveSelectFieldData(fieldData) {
      let response;
      try {
        response = await GlobalService.saveFieldData(
          this.selectedFieldUdp,
          this.selectedFieldUdp,
          this.getUser.token,
          fieldData.value
        );
      } catch (e) {
        let resObj = { status: 1, message: "Try again later" };
        resObj["selection"] = this.selectedFieldUdp;
        resObj["value"] = fieldData.value;
        this.showResponseAlert(resObj);
      }
      response["selection"] = this.selectedFieldUdp;
      response["value"] = fieldData.value;
      if (response.status === "0") {
        this.showResponseAlert(response);
      } else {
        this.showResponseAlert(response);
      }
    },
    // to show the reponse alert after update field
    showResponseAlert(text) {
      // prop function to show response alert
      this.responseAlert(text);
    }
  },
  props: {
    subMenu: {
      type: Object,
      default: undefined
    },
    subMenuData: {
      type: Object,
      default: undefined
    },
    subMenuSelectData: {
      type: Array,
      default: () => []
    },
    responseAlert: {
      type: Function,
      default: undefined
    },
    subMenuOutputSetting: {
      type: Array,
      default: () => []
    },
    showHelpdialog: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style>
.timer-btn {
  line-height: 36px;
  min-height: 36px;
  font-size: 11px;
}
.v-messages__message {
  margin-top: 5px;
}
.fieldset {
  margin: 0 0 20px;
  padding: 35px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  border: 2px solid #455a64;
  background: rgba(255, 255, 255, 0.3);
}
.fieldset legend {
  margin: 0 auto;
  text-transform: capitalize;
  padding: 10px;
  font-size: 18px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  background: #455a64;
  color: #fff;
  font-family: Roboto, "Helvetica Neue", sans-serif;
  top: -30px;
  margin-top: -30px;
  position: relative;
}
.md-whiteframe-z2 {
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}
.help-ico svg {
  width: 36px;
  height: auto;
  fill: #455a64;
}
@media (max-width: 768px) {
  .sub-menu {
    display: none !important;
  }
  .panel-block {
    padding: 0 !important;
    margin-bottom: 10px;
  }
}
@media (max-width: 480px) {
  .fieldset {
    padding: 20px 15px;
  }
  .help-ico svg {
    width: 28px;
  }
  .title-boil {
    font-size: 12px !important;
    padding: 0 6px;
  }
  .fieldset legend {
    top: -15px;
  }
  .panel-block .v-input__slot {
    margin-bottom: 0;
  }
  .fieldset button {
    position: relative;
    left: -10px;
  }
  .fieldset button.timer-btn {
    width: 100%;
    height: auto;
  }
  .fieldset button div {
    font-size: 10px;
    line-height: 14px;
    white-space: normal;
  }
  .v-select__selections {
    padding-right: 0px;
    word-break: break-word;
    font-size: 12px;
    line-height: 14px;
  }
  .fieldset .v-input label {
    font-size: 12px;
  }
}
</style>
